<template>
  <div class="mb-20 lg:mb-[160px]">
    <FaqBanner />
    <FaqList class="mt-8" />
  </div>
</template>

<script>
import { renderHead } from '@helper/head/head-home'
import { mapGetters } from 'vuex'
import FaqList from '@/components/pages/faq/faq-list'
import FaqBanner from '@/components/pages/faq/faq-banner'

export default {
  name: 'PageFaq',
  components: { FaqBanner, FaqList },
  auth: false,
  layout: 'main',
  async asyncData ({ store }) {
    await store.dispatch('local/asyncDataFaq')
  },
  head () {
    return renderHead({ meta: this.getMeta })
  },
  computed: {
    ...mapGetters('global', ['getMeta'])
  }
}
</script>

<style scoped>

</style>
